import "./BookAppointment.module.css";
import WebsiteHeader from "@/reusable_sections/Header";
import InitiateContact from "./sections/InitiateContact";
import OurHeadquarters from "./sections/OurHeadquarters";
import ConsigliPro from "./sections/ConsigliPro";
import Footer from "@/reusable_sections/Footer";
export default function BookAppointmentPage() {
  return <div>
      <WebsiteHeader />
      <InitiateContact />
      <OurHeadquarters />
      <ConsigliPro />
      <Footer />
    </div>;
}